"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const contexted_domainer_1 = require("./contexted_domainer");
const operators_1 = require("rxjs/operators");
class Widget extends contexted_domainer_1.ContextedDomainer {
    isTarget(p, rect) {
        // Default implementation
        return p.x >= rect.origin.x &&
            p.y >= rect.origin.y &&
            p.x < rect.origin.x + rect.size.width &&
            p.y < rect.origin.y + rect.size.height;
    }
    // TEST OVERRIDE
    connecting$(source, destination) {
        return source.pipe(operators_1.takeUntil(this.shutdown$)).subscribe(destination);
    }
}
exports.Widget = Widget;
